/* eslint-disable no-shadow */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Outlet, useLocation } from 'react-router-dom';
import { fetchMarketingCollections } from '@resy/ui-kitchen';
import { selectIsAuthenticated } from '../../../../../../ui-kitchen/src/reducers/authTokenSlice';
import { setFunctionalCookie } from '../../../../../../ui-kitchen/src/utils/resyUCMCookieUtils';
import { GDA_MEMBER_URL } from '../../AmexMarketingUtils/constants';

const COLLECTIONS_KEY = 'ny-1';

const AmexMarketingProvider = (props) => {
  const {
    $rootScope, Analytics, collections, getMarketingCollections, ipdata, isAuthenticated, selectedLocation,
  } = props;
  const isMobile = !$rootScope.matchMedia.ipadLandscape;
  const loc = useLocation();
  const active = loc.pathname.substring(1);
  const { loaded = false, loadedFromCookie, ...newUserLocation } = ipdata;

  useEffect(
    () => setFunctionalCookie(
      'userLocation',
      newUserLocation,
      { expires: moment().add('1', 'day').toDate() }
    ),
    [loaded]
  );

  function setDynamicTermsTitle(pageTitle) {
    $rootScope.metadata.title = pageTitle;
  }

  function showSignupModal() {
    $rootScope.$broadcast('MODAL', 'signup');
  }

  function showAuthModal(successCallback) {
    $rootScope.$broadcast('MODAL', 'signin', { successCallback });
  }

  function onLogin() {
    Analytics.event('Login button clicked', {
      category: 'User',
      label: 'resy.com',
    });
    $rootScope.$broadcast('MODAL', 'signin');
  }
  function loadNotifyModal({
    activeNotifications,
    selectedDate,
    selectedQuantity,
    notifyService,
    venueId,
    venueName,
  }) {
    // needed to normalize the start and end values for the notify modal
    const normalizedActiveNotifications = {};
    Object.keys(activeNotifications).forEach((item) => {
      const {
        time_preferred_end, // eslint-disable-line camelcase
        time_preferred_start, // eslint-disable-line camelcase
        ...args
      } = activeNotifications[item];

      normalizedActiveNotifications[item] = {
        ...args,
        end: time_preferred_end,
        start: time_preferred_start,
      };
    });

    $rootScope.$broadcast('MODAL', 'notify', {
      activeNotifications: normalizedActiveNotifications,
      locationSlug: selectedLocation.url_slug,
      selectedDate,
      selectedQuantity,
      notifyService,
      venueId,
      venueName,
    });
  }

  useEffect(() => {
    if (active === 'global-dining-access/directory' || active === 'global-dining-access' || active === GDA_MEMBER_URL) {
      getMarketingCollections({ location_id: 'ny', include_algo: 1 });
    }
  }, []);

  return (
    <article>
      <section>
        <div>
          <Outlet context={{
            collections,
            isAuthenticated,
            isMobile,
            onLogin,
            loadNotifyModal,
            showSignupModal,
            setDynamicTermsTitle,
            showAuthModal,
          }}
          />
        </div>
      </section>
    </article>
  );
};

const mapStateToProps = (state) => {
  const {
    collections,
    resyLocations,
    resyCore,
    ipdata,
  } = state;
  return {
    collections: collections.lists?.marketing?.[COLLECTIONS_KEY]?.all || [],
    isAuthenticated: selectIsAuthenticated(state),
    selectedLocation: resyLocations.selected || {},
    selectedCoreISODate: resyCore.selectedCoreISODate,
    selectedCoreSeats: resyCore.selectedCoreSeats,
    ipdata,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMarketingCollections: (data) => dispatch(fetchMarketingCollections(data)),
});

AmexMarketingProvider.propTypes = {
  $rootScope: PropTypes.shape({
    $broadcast: PropTypes.func,
    $on: PropTypes.func,
    isBackdropOpen: PropTypes.bool,
    metadata: PropTypes.shape({
      title: PropTypes.string,
    }),
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      ipadLandscape: PropTypes.bool,
      xl: PropTypes.bool,
    }),
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  collections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  getMarketingCollections: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  selectedCoreISODate: PropTypes.string.isRequired,
  selectedCoreSeats: PropTypes.number.isRequired,
  selectedLocation: PropTypes.shape({
    code: PropTypes.string,
    url_slug: PropTypes.string,
  }).isRequired,
  ipdata: PropTypes.shape({
    loaded: PropTypes.bool.isRequired,
    loadedFromCookie: PropTypes.bool.isRequired,
  }).isRequired,
};

export { AmexMarketingProvider as ComponentUnderTest, mapStateToProps, mapDispatchToProps };
export default connect(mapStateToProps, mapDispatchToProps)(AmexMarketingProvider);
